import { render, staticRenderFns } from "./buyCryptocurrency.vue?vue&type=template&id=20f034ca"
import script from "./buyCryptocurrency.vue?vue&type=script&lang=js"
export * from "./buyCryptocurrency.vue?vue&type=script&lang=js"
import style0 from "./buyCryptocurrency.vue?vue&type=style&index=0&id=20f034ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports